import React, {Component} from 'react'
import {FormattedMessage} from 'react-intl'
import EmailEvent from "./emailevent.component.jsx";

class EmailOpenedEvent extends Component {

    constructor(props, context) {
        super(props, context)
        this.state = {
            object: this.props.object || null,
            proposal: this.props.proposal || null,
            quote: this.props.quote || null,
            invoice: this.props.invoice || null,
            modal: '',
        }
    }

    componentWillReceiveProps(nextProps, nextContext) {
        this.setState({
            object: nextProps.object || null,
            quote: nextProps.quote || null,
            invoice: nextProps.invoice || null,
            proposal: nextProps.proposal || null,
        })
    }

    render() {
        const obj = this.state.invoice || this.state.quote
        if (!obj) {
            return ''
        }
        return <EmailEvent
            object={this.state.object}
            proposal={this.state.proposal}
            quote={this.state.quote}
            text={<FormattedMessage
                id="common.analytics.events.email_clicked.text"
                defaultMessage="{identifier} has been opened from the email you sent"
                values={{
                    identifier: obj.attributes.identifier
                }}
            />}
            icon={'hand-point-up'}
        />
    }

}

export default EmailOpenedEvent





// WEBPACK FOOTER //
// ./src/quote/analytics/events/email-clicked.component.jsx